
<template>
  <!--新增产品分类-->
  <x-addCategory></x-addCategory>
</template>

<script>
export default {
  name: 'aadCategory',
  data () {
    return {};
  },
  mounted () {
  },
  methods: {
  }
};
</script>



// WEBPACK FOOTER //
// src/components/device/category/product/addProductCate.vue